import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class FeaturesAlt {
	constructor(el) {
		this.el = el
		this.list = el.querySelector('.features-alt__list')
		this.features = el.querySelectorAll('.features-alt__entry')
		this.media = el.querySelector('.features-alt__media-holder')
		this.images = el.querySelectorAll('.features-alt__image.desktop')

		if (window.innerWidth > 650) {
			this.pinMedia()
			this.animateRows()
		}
	}
	pinMedia() {
		const tl = gsap.timeline({
			scrollTrigger: {
				pin: true,
				pinSpacing: false,
				trigger: this.media,
				endTrigger: this.features[this.features.length - 1],
				start: 'center center',
				end: 'center center',
				scrub: 1
			} 
		})
	}
	animateRows() {
		this.features.forEach((feature, i) => {

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: feature,
					start: 'top 80%',
					end: 'bottom 20%',
					// snap: 0.55,
					scrub: 0.75
				},
			})
			tl.to(feature, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'power1.out',
				duration: 1
			})
			tl.to(this.images[i], {
				duration: 1,
				clipPath: 'inset(0% 0 0 0)',
				ease: 'power2.out',
			}, '<')
			tl.to(feature, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'none',
				duration: 0.2
			})
			tl.to(feature, {
				scale: 0.9,
				opacity: 0.4,
				filter: 'blur(6px)',
				ease: 'power1.in',
				duration: 1
			})
			if (this.images[i] != this.images[this.images.length - 1]) {
				tl.to(this.images[i], {
					duration: 1,
					clipPath: 'inset(0 0 100% 0)',
					ease: 'power2.in',
				}, '<')
			}
		})
	}
}

export const initFeaturesAlt = () => {
	document.querySelectorAll('.features-alt').forEach(el => {
		new FeaturesAlt(el)
	})
}

export default () => {}